'use client';
import React__default from "react";
function useDisclosure(args) {
  const [isOpened, setIsOpened] = React__default.useState(
    (args == null ? void 0 : args.isDefaultOpened) ?? false
  );
  const onOpen = React__default.useCallback(() => {
    setIsOpened(true);
  }, [setIsOpened]);
  const onClose = React__default.useCallback(() => {
    setIsOpened(false);
  }, [setIsOpened]);
  const onToggle = React__default.useCallback(() => {
    setIsOpened((prev) => !prev);
  }, [setIsOpened]);
  return {
    isOpened,
    onOpen,
    onClose,
    onToggle,
    setIsOpened
  };
}
export {
  useDisclosure
};
